const timelineItem = (state, action) => {
  switch (action.type) {
    case 'SET_TIMELINE':
      return {
        ...state,
        folded: true,
      };
    case 'TOGGLE_TIMELINE_ITEM':
      if (state.ouid !== action.payload.ouid) {
        return state;
      }
      return {
        ...state,
        folded: !state.folded,
      };
    default:
      return state;
  }
};

export default (state = [], action) => {
  switch (action.type) {
    case 'SET_TIMELINE':
      return action.payload.timeline.map(t => timelineItem(t, action));
    case 'TOGGLE_TIMELINE_ITEM':
      return state.map(t => timelineItem(t, action));
    default:
      return state;
  }
};
